/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/app/Broadcasting/BroadcastChannel.php */
export const broadcastChannel = {
	OrganisationPaymentMethod: (params: { organisation: string | number }): string =>
		`organisations.${params.organisation}.payment-methods`,
	OrganisationProfiles: (params: { organisation: string | number }): string =>
		`organisations.${params.organisation}.profiles`,
	OrganisationSubscription: (params: { organisation: string | number }): string =>
		`organisations.${params.organisation}.subscription`,
	OrganisationWallet: (params: { organisation: string | number }): string =>
		`organisations.${params.organisation}.wallet`,
	OrganisationCandidateFile: (params: { organisation: string | number }): string =>
		`organisations.${params.organisation}.candidate-files`,
	OrganisationCandidateProfile: (params: { organisation: string | number }): string =>
		`organisations.${params.organisation}.candidate-profiles`,
	OrganisationWhatsAppAiAgent: (params: { organisation: string | number }): string =>
		`organisations.${params.organisation}.whatsapp-ai-agent`,
	AppReleases: 'releases',
} as const

/** @see backend/nexus/app/Broadcasting/BroadcastChannel.php */
export type BroadcastChannel = (typeof broadcastChannel)[keyof typeof broadcastChannel]
